import React, { useState } from "react";
import PDFViewer from "./PDFViewer";
import moment from "moment";
import { InvoicePaymentStatus, UploadInvoiceWithPaymentTabNames } from "../../../proposal/TermSheet/components/props";
import { AppPermissions, capitalizeAllFirstLettersOfWords, Customer, getPaymentStatus, LeadAssigneeChangeReason, ListEntityType, useHasPermission } from "../../../../core";
import { ContainerLoader } from "../../../../components/loader";
import { DownloadLink } from "../../../../components/render-file/DownloadLink";
import { DropdownList } from "react-widgets";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import { toastr } from "react-redux-toastr";
import { PaymentSummaryPopup } from "./payment-summary-popup";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DateRangeListFilter from "../../../../core/components/list-filters/DateRangeListFilter";
import { InvoiceCopyType, InvoicePaymentHistory } from "./UploadInvoice";
import { useForm } from "react-hook-form";
import { UploadTabNames } from "./props";

interface IDateRange {
  startDate?: Date;
  endDate?: Date;
}

export interface RevertForm {
  reason: {
    _id: string;
    code: string;
    reason: string;
    visibility: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  refundMethod: {
    name: string;
    value: string;
  };
  comment: string;
}

const DocumentView: React.FunctionComponent<{
  currentFile: any;
  reload?: () => void;
  onEdit?: () => void;
  onAddTransaction: () => void;
  changeDocument: (id: string) => void;
  title?: string;
  paymentHistoryLoading?:boolean
  noBoarder?: boolean;
  isLandlordCopy?: boolean;
  paymentHistory: InvoicePaymentHistory[];
  setDateFilters: ({startDate, endDate}:{startDate?: Date, endDate?: Date})=>void;
  dateFilters: IDateRange;
  mainTab?: UploadTabNames;
}> = (props) => {
  const [tabName, setTabName] = React.useState<UploadInvoiceWithPaymentTabNames>(
    UploadInvoiceWithPaymentTabNames.InvoiceDetails
  );
  const [summaryPopup, SetSummaryPopup] = useState(false);
  const [selectedTransactionIds, setSelectedTransactionIds] = useState<string[]>([]);

  const form = useForm<RevertForm>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const setElementActive = (tabValue: UploadInvoiceWithPaymentTabNames) => {
    setTabName(tabValue);
  };

  const canRevertInvoiceTransaction = useHasPermission(
    AppPermissions.RevertInvoicePaymentTransaction
  );

  const camelCaseToWords = (str:any)=>{
    return str.match(/^[a-z]+|[A-Z][a-z]*/g).map((x:any) => {
        return x[0].toUpperCase() + x.substr(1).toLowerCase();
    }).join(' ');
  };

  const { data: changeReasons } = useDataLoader<LeadAssigneeChangeReason[]>(
    () => api.changeLeadAssigneeUserReasonService.loadAllChangeLeadAssigneeRejectReason({ entityType: 'InvoiceTransactionRevert' })
  );

  const onSubmitModalCRM = async (
    data:RevertForm
  ) => {
    try {
      const response =  await api.invoice.revertTransaction(
        { reason: data.reason.reason, comment: data.comment, refundAmount: props.paymentHistory.filter(item => selectedTransactionIds.includes(item._id)).reduce((acc, curr) => { return acc + curr.amount }, 0), paymentHistoryIds: selectedTransactionIds, refundMethod: data.refundMethod.value, invoiceCopyType: props.mainTab === UploadTabNames.InvoiceForCustomer ?  InvoiceCopyType.Client : InvoiceCopyType.LandLord},
      );
      setSelectedTransactionIds([])
      props.reload?.();
      toastr.success(
        "Success",
        "Transaction Successfully Reverted"
      );
    } catch (error) {
        // setSelectedTransactionIds([])
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
    }
  };

  
  const pendingAmount =()=>{
    if(props.mainTab === UploadTabNames.InvoiceForCustomer){
        return ((props.currentFile?.document?.paymentDetails?.amount + props.currentFile?.document?.paymentDetails?.taxCgst + props.currentFile?.document?.paymentDetails?.taxSgst) - props.currentFile?.document?.paymentDetails?.amountPaid)
    }else if(props.mainTab === UploadTabNames.InvoiceForLandlord){
        return ((props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.amount + props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.taxCgst + props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.taxSgst) - props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.amountPaid)
    }else{
        return 0
    }
  }   

  const amountPaid = ()=>{
    if(props.mainTab === UploadTabNames.InvoiceForCustomer){
        return props.currentFile?.document?.paymentDetails?.amountPaid
    }else if(props.mainTab === UploadTabNames.InvoiceForLandlord){
        return props.currentFile?.seperateDocumentForLandlord?.paymentDetails?.amountPaid
    }else{
        return 0
    }
  }

  const currentDocument = !props.isLandlordCopy
    ? props.currentFile?.document?.draftDocument
    : props.currentFile?.seperateDocumentForLandlord?.draftDocument;

  const document = props.isLandlordCopy
  ? props.currentFile?.seperateDocumentForLandlord
  : props.currentFile?.document;

  if(props.paymentHistoryLoading){
    return <ContainerLoader height={200}></ContainerLoader>
  }
  return (
    <>
      <div className={`bg-white ${
        props.noBoarder ? "" : "border"
      } rounded-sm signed-time-wrap`}>
        <div className="h-100 px-4 row">
          <div
            className={"col-12 bg-white"}
          >
              <div
              className="border-bottom d-flex align-items-center justify-content-between mb-3"
              style={{ margin: "0 -24px", padding: "0 24px" }}
            >
              <ul
                className="d-flex list-unstyled tab-underline font-sm font-weight-semibold text-nowrap overflow-auto mb-0"
                id="activity-tab"
                role="tablist"
              >
                <li className="nav-item pr-4 " role="presentation">
                  <a
                    className={`cursor-pointer nav-link position-relative px-0 py-3 text-gray-600 ${
                      tabName ===
                      UploadInvoiceWithPaymentTabNames.InvoiceDetails
                        ? "active"
                        : ""
                    }`}
                    onClick={(e) => {
                      setElementActive(
                        UploadInvoiceWithPaymentTabNames.InvoiceDetails
                      );
                    }}
                  >
                    <span className="py-1 d-inline-flex">Invoice Details</span>
                  </a>
                </li>
                {document?.paymentDetails &&
                  document?.paymentDetails?.paymentStatus !== InvoicePaymentStatus.PaymentPending &&
                  (props?.paymentHistory?.length > 0 || (props.dateFilters.startDate || props.dateFilters.endDate )) && (
                    <li className="nav-item pr-4 pl-4" role="presentation">
                      <a
                        className={`cursor-pointer nav-link position-relative px-0 py-3 text-gray-600 ${
                          tabName ===
                          UploadInvoiceWithPaymentTabNames.PaymentHistory
                            ? "active"
                            : ""
                        }`}
                        onClick={(e) => {
                          setElementActive(
                            UploadInvoiceWithPaymentTabNames.PaymentHistory
                          );
                        }}
                      >
                        <span className="py-1 d-inline-flex">
                          Payment History
                        </span>
                      </a>
                    </li>
                  )}
              </ul>

              {document?.paymentDetails &&
                  // document?.paymentDetails?.paymentStatus !== InvoicePaymentStatus.PaymentPending &&
                  (props?.paymentHistory?.length > 0 || (props.dateFilters.startDate || props.dateFilters.endDate )) &&<div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-primary px-4 font-normal font-weight-bold py-2 "
                  onClick={props.onAddTransaction}
                >
                  Add Transaction
                </button>
                <div
                  className="ml-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => SetSummaryPopup(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <path
                      d="M16.3158 1.27344H11.8158C11.592 1.27344 11.3774 1.36233 11.2192 1.52057C11.061 1.6788 10.9721 1.89341 10.9721 2.11719C10.9721 2.34096 11.061 2.55558 11.2192 2.71381C11.3774 2.87204 11.592 2.96094 11.8158 2.96094H14.2788L6.19082 11.0489C6.0333 11.2073 5.94501 11.4217 5.94531 11.6451C5.94562 11.8685 6.03449 12.0826 6.19244 12.2406C6.35039 12.3985 6.56454 12.4874 6.78792 12.4877C7.01129 12.488 7.22568 12.3997 7.38406 12.2422L15.4721 4.15418V6.61719C15.4721 6.84096 15.561 7.05558 15.7192 7.21381C15.8774 7.37204 16.092 7.46094 16.3158 7.46094C16.5396 7.46094 16.7542 7.37204 16.9124 7.21381C17.0707 7.05558 17.1596 6.84096 17.1596 6.61719V2.11719C17.1596 1.89341 17.0707 1.6788 16.9124 1.52057C16.7542 1.36233 16.5396 1.27344 16.3158 1.27344Z"
                      fill="#3F4241"
                    />
                    <path
                      d="M16.3125 9.14844C16.0887 9.14844 15.8741 9.23733 15.7159 9.39557C15.5576 9.5538 15.4688 9.76841 15.4688 9.99219V15.8984H2.53125V2.96094H8.4375C8.66128 2.96094 8.87589 2.87204 9.03412 2.71381C9.19236 2.55558 9.28125 2.34096 9.28125 2.11719C9.28125 1.89341 9.19236 1.6788 9.03412 1.52057C8.87589 1.36233 8.66128 1.27344 8.4375 1.27344H1.6875C1.46372 1.27344 1.24911 1.36233 1.09088 1.52057C0.932645 1.6788 0.84375 1.89341 0.84375 2.11719V16.7422C0.84375 16.966 0.932645 17.1806 1.09088 17.3388C1.24911 17.497 1.46372 17.5859 1.6875 17.5859H16.3125C16.5363 17.5859 16.7509 17.497 16.9091 17.3388C17.0674 17.1806 17.1562 16.966 17.1562 16.7422V9.99219C17.1562 9.76841 17.0674 9.5538 16.9091 9.39557C16.7509 9.23733 16.5363 9.14844 16.3125 9.14844Z"
                      fill="#3F4241"
                    />
                  </svg>
                </div>
              </div>}
            </div>
            {tabName === UploadInvoiceWithPaymentTabNames.InvoiceDetails && (
              <>
                <div className="px-4 py-3">
                  <div className="row no-gutters">
                    <div className="">
                    {/* <div className="col-md-6 col-12 "> */}
                      {/* <div className="d-flex align-items-center">
                        <div>
                          {" "}
                          <h5 className="mb-3 font-normal font-sm font-weight-semibold mb-0">
                            {props.title}
                          </h5>
                        </div>
                      </div> */}

                      <span
                        className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                        style={{ textTransform: "none" }}
                      >
                        Created By{" "}
                        <span className="text-dark">
                          {props.isLandlordCopy ? props.currentFile?.seperateDocumentForLandlord?.uploadedBy?.name : props.currentFile?.document?.uploadedBy?.name}
                        </span>{" "}
                        on{" "}
                        <span className="text-dark">
                          {" "}
                          {/* {moment(props.currentFile?.createdAt).format(
                            "DD MMM YYYY hh:mm A"
                          )} */}
                           {moment(props.isLandlordCopy ? props.currentFile?.seperateDocumentForLandlord?.createdAt : props.currentFile?.document?.createdAt).format(
                    "DD MMM YYYY hh:mm A"
                  )}
                        </span>
                      </span>
                      {document?.paymentDetails && (
                        <>
                         {document.paymentDetails?.lastTransaction?.createdAt && <span
                            className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                            style={{ textTransform: "none" }}
                            >
                            Last Transaction Recorded by {" "}
                            <span className="text-dark">
                              {document.paymentDetails?.lastTransaction?.paidBy}
                            </span>{" "}
                            on{" "}
                            <span className="text-dark">
                              {" "}
                              {moment(document.paymentDetails?.lastTransaction?.createdAt).format(
                                "DD MMM YYYY hh:mm A"
                              )}
                            </span>
                          </span>}
                          <span
                          className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                          style={{ textTransform: "none" }}
                        >
                          Net Amount{" "}:
                          <span className="text-dark ml-2">
                          ₹{document.paymentDetails.amount?.toLocaleString('en-IN')}
                          </span>{" "}
                          </span>
                          <span
                            className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                            style={{ textTransform: "none" }}
                          >
                            Invoice Date{" "}:
                            <span className="text-dark ml-2">
                              {moment(document.paymentDetails.date).format("DD/MMM/YYYY")}
                            </span>{" "}
                          </span>
                          <span
                            className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                            style={{ textTransform: "none" }}
                          >
                            Due Date{" "}:
                            <span className="text-dark ml-2">
                              {moment(document.paymentDetails.dueDate).format("DD/MMM/YYYY")}
                            </span>{" "}
                          </span>
                          <span
                            className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                            style={{ textTransform: "none" }}
                          >
                            SGST{" "}:
                            <span className="text-dark ml-2">
                            ₹{document.paymentDetails.taxSgst}
                            </span>{" "}
                          </span>
                          <span
                            className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                            style={{ textTransform: "none" }}
                            >
                            CGST{" "}:
                            <span className="text-dark ml-2">
                            ₹{document.paymentDetails.taxCgst}
                            </span>{" "}
                          </span>
                          <span
                            className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                            style={{ textTransform: "none" }}
                          >
                            Gross Amount{" "}:
                            <span className="text-dark ml-2">
                            ₹{(document.paymentDetails.amount + document.paymentDetails.taxCgst + document.paymentDetails.taxSgst).toLocaleString('en-IN')}
                            </span>{" "}
                            
                          </span>
                        </>
                      )}
                      {/* {document?.paymentDetails && (
                        <span
                          className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                          style={{ textTransform: "none" }}
                        >
                          Amount Paid{" : "}
                          <span className="text-dark">
                            {document?.paymentDetails?.amountPaid}
                          </span>{" "}
                        </span>
                      )} */}
                    </div>
                  </div>
                  <div className="mt-4">
                    <PDFViewer
                      pdfUrl={currentDocument?.location!}
                      file={currentDocument}
                    ></PDFViewer>
                  </div>
                </div>
              </>
            )}
            {tabName === UploadInvoiceWithPaymentTabNames.PaymentHistory && (
                <>
                <div className="">
                  <div
                    className="d-flex align-items-center border-bottom pb-3"
                    style={{ margin: "0 -24px", padding: "0 24px" }}
                  >
                    <div className="w-100 d-flex justify-content-between align-items-center ">
                      <div>
                        {" "}
                        <h5 className="font-normal font-weight-semibold mb-0">
                          Payment History
                        </h5>
                      </div>
                      <div className="d-flex align-items-center mr-3 pr-1">
                        <div className="date-ranger-picker d-flex align-items-center">
                          {/* <DateRangePicker
                            onCallback={(start, end, label) => {
                              props.setDateFilters({
                                startDate: start.toDate(),
                                endDate: end.toDate(),
                              });
                            }}
                            initialSettings={{
                              startDate: props.dateFilters.startDate,
                              endDate: props.dateFilters.endDate,
                              locale: { format: "DD MMM YYYY" },
                            }}
                          >
                            <input
                              type="text"
                              className="form-control border-0 font-weight-semibold px-0"
                            />
                          </DateRangePicker> */}
                          <DateRangeListFilter
                            default={props.dateFilters}
                            onChange={(data?: IDateRange) => {
                              props.setDateFilters({
                                startDate: data?.startDate,
                                endDate: data?.endDate,
                              });
                            }}
                          />
                          <div className="ico ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="16"
                              viewBox="0 0 18 16"
                              fill="none"
                            >
                              <path
                                d="M14.006 6.11636H4.56217V8.01466H14.006V6.11636ZM15.7979 1.78125H14.9498V0H13.0622V1.78125H5.50599V0H3.6127L3.61459 1.78125H2.48126C1.43571 1.78125 0.786905 1.78125 0.786905 1.78125L0.78125 16C0.78125 16 1.62899 16 2.66889 16H17.7812C17.7812 16 17.7812 15.1475 17.7812 14.1017V1.78125C17.7812 1.78125 16.8435 1.78125 15.7979 1.78125ZM15.8936 14.1017H2.66889V4.21807H15.8936V14.1017ZM11.1745 9.91864H4.56217V11.8169H11.1745V9.91864Z"
                                fill="#686868"
                              />
                            </svg>
                          </div>
                        </div>
                        {/* <span className="ml-4 cursor-pointer">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                          >
                            <path
                              d="M15.442 3.25781H17.7187C18.3226 3.25781 18.9017 3.49769 19.3287 3.92467C19.7557 4.35165 19.9955 4.93076 19.9955 5.5346V17.3739C19.9955 17.9777 19.7557 18.5568 19.3287 18.9838C18.9017 19.4108 18.3226 19.6507 17.7187 19.6507H4.05804C3.45419 19.6507 2.87509 19.4108 2.44811 18.9838C2.02112 18.5568 1.78125 17.9777 1.78125 17.3739V5.5346C1.78125 4.93076 2.02112 4.35165 2.44811 3.92467C2.87509 3.49769 3.45419 3.25781 4.05804 3.25781H6.33482"
                              stroke="#3F4241"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.33594 11.7058L10.8895 16.2594L15.4431 11.7058M10.8895 0.999917V15.3487"
                              stroke="#3F4241"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="payment-count-wrap py-3 border-bottom"
                    style={{ margin: "0 -24px", padding: "0 24px" }}
                  >
                    <ul className="list-unstyled mb-0 d-flex">
                      <li className="mr-5 pr-5">
                        <span className="title font-sm ">Invoice Gross Amount</span>
                        <span className="count font-lg font-weight-bold d-block pt-1">
                          ₹{(document.paymentDetails.amount + document.paymentDetails.taxCgst + document.paymentDetails.taxSgst).toLocaleString('en-IN')}
                        </span>
                      </li>
                      <li className="mr-5 pr-5">
                        <span className="title font-sm">Total Paid </span>
                        <span className="count font-lg font-weight-bold d-block pt-1">
                          ₹{amountPaid().toLocaleString('en-IN')  || 0}
                        </span>
                      </li>

                      <li className="mr-5 pr-5">
                        <span className="title font-sm">Balance to Pay</span>
                        <span className="count font-lg font-weight-bold d-block pt-1">
                        ₹{pendingAmount().toLocaleString('en-IN')  || 0}
                        </span>
                      </li>


                    </ul>
                  </div>
                  <div className="payment-transation-table table table-responsive">
                    <table>
                      <thead>
                        <tr>
                          <th>Payment Method</th>
                          <th>Amount </th>
                          <th>Payment Date</th>
                          <th>Paid By  </th>
                          <th>Comment  </th>
                          <th>Bank</th>
                          {/* <th>Receipt</th> */}
                          <th>Transaction Recorded By </th>
                          <th>Transaction Recorded On </th>
                          <th>Status  </th>
                          <th>Cancelled Reason  </th>
                        </tr>
                      </thead>
                      <tbody>
                       {[...(props?.paymentHistory || [])].reverse()?.map((item)=> <tr>
                          <td>
                            <span>{camelCaseToWords(capitalizeAllFirstLettersOfWords(item.paymentMethod))}</span>
                            {/* <span className="text-xs d-block font-xxs pt-1 text-muted">
                              31/May/2021 6:14 PM
                            </span> */}
                          </td>
                          <td>₹{item.amount.toLocaleString('en-IN')}</td>
                          <td>{moment(item.paidAt).format("DD/MMM/YYYY")} </td>
                          <td>{item.paidBy}</td>
                          <td>{item.comments}</td>
                          <td>{item.bank}</td>
                          {/* <td>
                            {item.receipt && <DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                                View
                                </DownloadLink>}
                          </td> */}
                          <td>{item?.addedBy?.name}</td>
                          <td>{moment(item.createdAt).format("DD/MMM/YYYY hh:mm A")}</td>
                          <td>{getPaymentStatus(item.status)}</td>
                          <td>{item.reason}</td>
                        </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* <> 
                <div className="px-4 py-3">
                  <div className="row no-gutters">
                    <div className="col">
                      <div className="d-flex align-items-center">
                        <div>
                          {" "}
                          <h5 className="font-normal mb-3 font-sm font-weight-semibold mb-0">
                            Payment History
                          </h5>
                        </div>
                      </div>
                    {[...(props?.paymentHistory || [])].reverse()?.map((item:any)=>
                     <div className="mb-3 border-bottom pb-2 payment-history d-flex">
                      <div className="col-9">
                        <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Payment Method{" "}:</div>
                          <div className="col min-w-0 text-dark">{camelCaseToWords(capitalizeAllFirstLettersOfWords(item.paymentMethod))}</div>
                        </div>
                        <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Amount{" "}:</div>
                          <div className="col min-w-0 text-dark"> ₹{item.amount.toLocaleString('en-IN')}</div>
                        </div>
                        <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Payment Date{" "}:</div>
                          <div className="col min-w-0 text-dark">{moment(item.paidAt).format("DD/MMM/YYYY")}</div>
                        </div>
                        {item.paidBy &&<div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Paid By{" "}:</div>
                          <div className="col min-w-0 text-dark">{item.paidBy}</div>
                        </div>}
                        {item.comments &&<div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Comment{" "}:</div>
                          <div className="col min-w-0 text-dark">{item.comments}</div>
                        </div>}
                        {item.bank &&<div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Bank{" "}:</div>
                          <div className="col min-w-0 text-dark">{item.bank}</div>
                        </div>}
                        {item.receipt && (
                          <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">  
                            <div className="col-auto title">Receipt{" "}:</div>
                            <div className="col min-w-0 text-dark">
                                <DownloadLink file={item.receipt} target="_blank"   className="btn-link text-decoration-underline">
                                View
                                </DownloadLink>
                            </div>
                          </div>
                          )
                        }
                        <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Transaction Recorded By{" "}:</div>
                          <div className="col min-w-0 text-dark">{item?.addedBy?.name}</div>
                        </div>
                        <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Transaction Recorded On{" "}:</div>
                          <div className="col min-w-0 text-dark">{moment(item.createdAt).format("DD/MMM/YYYY hh:mm A")}</div>
                        </div>
                        {item.status === InvoicePaymentStatus.PaymentCancelled &&<div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Status{" "}:</div>
                          <div className="col min-w-0 text-dark">Cancelled</div>
                        </div>}
                        {item.status === InvoicePaymentStatus.PaymentCancelled && item.reason && <div className="row gutter-8 mt-2 font-xs text-gray-500 font-weight-semibold">
                          <div className="col-auto title">Cancelled Reason{" "}:</div>
                          <div className="col min-w-0 text-dark">{item.reason}</div>
                        </div>}
                      </div>
                      {(canRevertInvoiceTransaction && item.status !== InvoicePaymentStatus.PaymentCancelled) && <div className="col-3 flex-end">
                          <button
                            type="button"
                            className="btn btn-outline-primary bg-white text-primary font-normal font-weight-bold py-2 rounded"
                            style={{whiteSpace: 'nowrap'}}
                            onClick={() => {
                              setShowReasonModal({id: item._id, value: true})
                            }}
                          >
                            Revert Transaction
                          </button>
                      </div>}
                    </div>
                    )}
                    </div>
                  </div>
                </div>
              </> */}
              </>
            )}
          </div>
        </div>
      </div>
      {summaryPopup && (
        <PaymentSummaryPopup
        mainTab={props.mainTab}
        document={document}
        currentFile={props.currentFile}
        setSelectedTransactionIds={setSelectedTransactionIds}
        selectedTransactionIds={selectedTransactionIds}
         onSubmit={onSubmitModalCRM}
          form={form}
          paymentHistory={props.paymentHistory}
          changeReasons={changeReasons}
          onAddTransaction={props.onAddTransaction}
          onClose={() => {
            SetSummaryPopup(false);
          }}
        />
      )}
      {/* {showReasonModal.value === true && (
        <>
          <div
            className="modal fade show in"
            id="exampleModal"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
              <div className="modal-content rounded-0">
                <div className="modal-body ">
                  <div className="container">
                    <div className="form-group mb-3">
                      <label
                        htmlFor=""
                        className="font-sm font-weight-semibold"
                      >
                        Select Reason
                      </label>
                      <DropdownList
                        textField={"reason"}
                        valueField={"_id"}
                        placeholder={"Select reason for cancel/revert"}
                        data={changeReasons}
                        onChange={(e) => {
                          setReason(e)
                        }}
                      />
                    </div>
                    <div className="row">
                      <div className="col-auto mr-auto">
                        <button
                          type="button"
                          className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                          onClick={() => {
                            setShowReasonModal({id: '', value: false});
                            setReason(undefined);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                          onClick={() => onSubmitModalCRM()}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )} */}
    </>
  );
};

export default DocumentView;
